module.exports = __webpack_public_path__ + "static/img/myself.0203a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/myself.png
// module id = BRxi
// module chunks = 1